export const REPORTS_SERVICES_INIT = 'REPORTS_SERVICES_INIT'
export const REPORTS_SERVICES_DATA_SUCCESS = 'REPORTS_SERVICES_DATA_SUCCESS'
export const REPORTS_SERVICES_DATA_ERROR = 'REPORTS_SERVICES_DATA_ERROR'
export const REPORTS_SERVICES_LOADING = 'REPORTS_SERVICES_LOADING'
export const REPORTS_SERVICES_SORT = 'REPORTS_SERVICES_SORT'
